<div class="row" *ngIf="location">
  <div class="col-lg-12">
    <div class="grid">
      <p class="grid-header">Edit Location</p>
      <div class="grid-body">
        <div class="item-wrapper">
          <form>
            <div class="form-group">
              <label for="name">Company</label>
              <input [(ngModel)]="location.company" name="company" type="text" class="form-control"/>
            </div>
            <div class="form-group">
              <label for="org_id">Organization</label>
              <select [(ngModel)]="location.org_id" class="form-control ng-pristine ng-valid ng-touched" name="org_id" #org_id="ngModel" required>
                <option *ngFor="let subOrg of organizationService.subOrgs" [value]="subOrg.id">
                  {{subOrg.name}}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label for="address1">Address 1</label>
              <input [(ngModel)]="location.address1" name="address1" type="text" class="form-control"/>
            </div>
            <div class="form-group">
              <label for="address2">Address 2</label>
              <input [(ngModel)]="location.address2" name="address2" type="text" class="form-control"/>
            </div>
            <div class="form-group">
              <label for="address3">Address 3</label>
              <input [(ngModel)]="location.address3" name="address3" type="text" class="form-control"/>
            </div>
            <div class="form-group">
              <label for="tz">Timezone</label>
						  <select class="form-control" name="tz" [(ngModel)]="location.tz">
                <option value="Etc/GMT+12" ng-reflect-value="Etc/GMT+12">
								Dateline Standard Time
								</option><option value="Etc/GMT+11" ng-reflect-value="Etc/GMT+11">
								UTC-11
								</option><option value="Etc/GMT+10" ng-reflect-value="Etc/GMT+10">
								Hawaiian Standard Time
								</option><option value="America/Anchorage" ng-reflect-value="America/Anchorage">
								Alaskan Standard Time
								</option><option value="America/Santa_Isabel" ng-reflect-value="America/Santa_Isabel">
								Pacific Standard Time (Mexico)
								</option><option value="America/Dawson" ng-reflect-value="America/Dawson" selected="true">
								Pacific Standard Time
								</option><option value="America/Creston" ng-reflect-value="America/Creston">
								US Mountain Standard Time
								</option><option value="America/Chihuahua" ng-reflect-value="America/Chihuahua">
								Mountain Standard Time (Mexico)
								</option><option value="America/Boise" ng-reflect-value="America/Boise">
								Mountain Standard Time
								</option><option value="America/Belize" ng-reflect-value="America/Belize">
								Central America Standard Time
								</option><option value="America/Chicago" ng-reflect-value="America/Chicago">
								Central Standard Time
								</option><option value="America/Bahia_Banderas" ng-reflect-value="America/Bahia_Banderas">
								Central Standard Time (Mexico)
								</option><option value="America/Regina" ng-reflect-value="America/Regina">
								Canada Central Standard Time
								</option><option value="America/Bogota" ng-reflect-value="America/Bogota">
								SA Pacific Standard Time
								</option><option value="America/Detroit" ng-reflect-value="America/Detroit">
								Eastern Standard Time
								</option><option value="America/Indiana/Marengo" ng-reflect-value="America/Indiana/Marengo">
								US Eastern Standard Time
								</option><option value="America/Caracas" ng-reflect-value="America/Caracas">
								Venezuela Standard Time
								</option><option value="America/Asuncion" ng-reflect-value="America/Asuncion">
								Paraguay Standard Time
								</option><option value="America/Glace_Bay" ng-reflect-value="America/Glace_Bay">
								Atlantic Standard Time
								</option><option value="America/Campo_Grande" ng-reflect-value="America/Campo_Grande">
								Central Brazilian Standard Time
								</option><option value="America/Anguilla" ng-reflect-value="America/Anguilla">
								SA Western Standard Time
								</option><option value="America/Santiago" ng-reflect-value="America/Santiago">
								Pacific SA Standard Time
								</option><option value="America/St_Johns" ng-reflect-value="America/St_Johns">
								Newfoundland Standard Time
								</option><option value="America/Sao_Paulo" ng-reflect-value="America/Sao_Paulo">
								E. South America Standard Time
								</option><option value="America/Argentina/La_Rioja" ng-reflect-value="America/Argentina/La_Rioja">
								Argentina Standard Time
								</option><option value="America/Araguaina" ng-reflect-value="America/Araguaina">
								SA Eastern Standard Time
								</option><option value="America/Godthab" ng-reflect-value="America/Godthab">
								Greenland Standard Time
								</option><option value="America/Montevideo" ng-reflect-value="America/Montevideo">
								Montevideo Standard Time
								</option><option value="America/Bahia" ng-reflect-value="America/Bahia">
								Bahia Standard Time
								</option><option value="America/Noronha" ng-reflect-value="America/Noronha">
								UTC-02
								</option><option value="America/Scoresbysund" ng-reflect-value="America/Scoresbysund">
								Azores Standard Time
								</option><option value="Atlantic/Cape_Verde" ng-reflect-value="Atlantic/Cape_Verde">
								Cape Verde Standard Time
								</option><option value="Africa/Casablanca" ng-reflect-value="Africa/Casablanca">
								Morocco Standard Time
								</option><option value="America/Danmarkshavn" ng-reflect-value="America/Danmarkshavn">
								UTC
								</option><option value="Atlantic/Canary" ng-reflect-value="Atlantic/Canary">
								GMT Standard Time
								</option><option value="Africa/Abidjan" ng-reflect-value="Africa/Abidjan">
								Greenwich Standard Time
								</option><option value="Arctic/Longyearbyen" ng-reflect-value="Arctic/Longyearbyen">
								W. Europe Standard Time
								</option><option value="Europe/Belgrade" ng-reflect-value="Europe/Belgrade">
								Central Europe Standard Time
								</option><option value="Africa/Ceuta" ng-reflect-value="Africa/Ceuta">
								Romance Standard Time
								</option><option value="Europe/Sarajevo" ng-reflect-value="Europe/Sarajevo">
								Central European Standard Time
								</option><option value="Africa/Algiers" ng-reflect-value="Africa/Algiers">
								W. Central Africa Standard Time
								</option><option value="Africa/Windhoek" ng-reflect-value="Africa/Windhoek">
								Namibia Standard Time
								</option><option value="Asia/Nicosia" ng-reflect-value="Asia/Nicosia">
								GTB Standard Time
								</option><option value="Asia/Beirut" ng-reflect-value="Asia/Beirut">
								Middle East Standard Time
								</option><option value="Africa/Cairo" ng-reflect-value="Africa/Cairo">
								Egypt Standard Time
								</option><option value="Asia/Damascus" ng-reflect-value="Asia/Damascus">
								Syria Standard Time
								</option><option value="Africa/Blantyre" ng-reflect-value="Africa/Blantyre">
								South Africa Standard Time
								</option><option value="Europe/Helsinki" ng-reflect-value="Europe/Helsinki">
								FLE Standard Time
								</option><option value="Europe/Istanbul" ng-reflect-value="Europe/Istanbul">
								Turkey Standard Time
								</option><option value="Asia/Jerusalem" ng-reflect-value="Asia/Jerusalem">
								Israel Standard Time
								</option><option value="Africa/Tripoli" ng-reflect-value="Africa/Tripoli">
								Libya Standard Time
								</option><option value="Asia/Amman" ng-reflect-value="Asia/Amman">
								Jordan Standard Time
								</option><option value="Asia/Baghdad" ng-reflect-value="Asia/Baghdad">
								Arabic Standard Time
								</option><option value="Europe/Kaliningrad" ng-reflect-value="Europe/Kaliningrad">
								Kaliningrad Standard Time
								</option><option value="Asia/Aden" ng-reflect-value="Asia/Aden">
								Arab Standard Time
								</option><option value="Africa/Addis_Ababa" ng-reflect-value="Africa/Addis_Ababa">
								E. Africa Standard Time
								</option><option value="Asia/Tehran" ng-reflect-value="Asia/Tehran">
								Iran Standard Time
								</option><option value="Asia/Dubai" ng-reflect-value="Asia/Dubai">
								Arabian Standard Time
								</option><option value="Asia/Baku" ng-reflect-value="Asia/Baku">
								Azerbaijan Standard Time
								</option><option value="Europe/Moscow" ng-reflect-value="Europe/Moscow">
								Russian Standard Time
								</option><option value="Indian/Mahe" ng-reflect-value="Indian/Mahe">
								Mauritius Standard Time
								</option><option value="Asia/Tbilisi" ng-reflect-value="Asia/Tbilisi">
								Georgian Standard Time
								</option><option value="Asia/Yerevan" ng-reflect-value="Asia/Yerevan">
								Caucasus Standard Time
								</option><option value="Asia/Kabul" ng-reflect-value="Asia/Kabul">
								Afghanistan Standard Time
								</option><option value="Antarctica/Mawson" ng-reflect-value="Antarctica/Mawson">
								West Asia Standard Time
								</option><option value="Asia/Karachi" ng-reflect-value="Asia/Karachi">
								Pakistan Standard Time
								</option><option value="Asia/Kolkata" ng-reflect-value="Asia/Kolkata">
								India Standard Time
								</option><option value="Asia/Colombo" ng-reflect-value="Asia/Colombo">
								Sri Lanka Standard Time
								</option><option value="Asia/Katmandu" ng-reflect-value="Asia/Katmandu">
								Nepal Standard Time
								</option><option value="Antarctica/Vostok" ng-reflect-value="Antarctica/Vostok">
								Central Asia Standard Time
								</option><option value="Asia/Dhaka" ng-reflect-value="Asia/Dhaka">
								Bangladesh Standard Time
								</option><option value="Asia/Yekaterinburg" ng-reflect-value="Asia/Yekaterinburg">
								Ekaterinburg Standard Time
								</option><option value="Asia/Rangoon" ng-reflect-value="Asia/Rangoon">
								Myanmar Standard Time
								</option><option value="Antarctica/Davis" ng-reflect-value="Antarctica/Davis">
								SE Asia Standard Time
								</option><option value="Asia/Novokuznetsk" ng-reflect-value="Asia/Novokuznetsk">
								N. Central Asia Standard Time
								</option><option value="Asia/Hong_Kong" ng-reflect-value="Asia/Hong_Kong">
								China Standard Time
								</option><option value="Asia/Krasnoyarsk" ng-reflect-value="Asia/Krasnoyarsk">
								North Asia Standard Time
								</option><option value="Asia/Brunei" ng-reflect-value="Asia/Brunei">
								Singapore Standard Time
								</option><option value="Antarctica/Casey" ng-reflect-value="Antarctica/Casey">
								W. Australia Standard Time
								</option><option value="Asia/Taipei" ng-reflect-value="Asia/Taipei">
								Taipei Standard Time
								</option><option value="Asia/Choibalsan" ng-reflect-value="Asia/Choibalsan">
								Ulaanbaatar Standard Time
								</option><option value="Asia/Irkutsk" ng-reflect-value="Asia/Irkutsk">
								North Asia East Standard Time
								</option><option value="Asia/Dili" ng-reflect-value="Asia/Dili">
								Tokyo Standard Time
								</option><option value="Asia/Pyongyang" ng-reflect-value="Asia/Pyongyang">
								Korea Standard Time
								</option><option value="Australia/Adelaide" ng-reflect-value="Australia/Adelaide">
								Cen. Australia Standard Time
								</option><option value="Australia/Darwin" ng-reflect-value="Australia/Darwin">
								AUS Central Standard Time
								</option><option value="Australia/Brisbane" ng-reflect-value="Australia/Brisbane">
								E. Australia Standard Time
								</option><option value="Australia/Melbourne" ng-reflect-value="Australia/Melbourne">
								AUS Eastern Standard Time
								</option><option value="Antarctica/DumontDUrville" ng-reflect-value="Antarctica/DumontDUrville">
								West Pacific Standard Time
								</option><option value="Australia/Currie" ng-reflect-value="Australia/Currie">
								Tasmania Standard Time
								</option><option value="Asia/Chita" ng-reflect-value="Asia/Chita">
								Yakutsk Standard Time
								</option><option value="Antarctica/Macquarie" ng-reflect-value="Antarctica/Macquarie">
								Central Pacific Standard Time
								</option><option value="Asia/Sakhalin" ng-reflect-value="Asia/Sakhalin">
								Vladivostok Standard Time
								</option><option value="Antarctica/McMurdo" ng-reflect-value="Antarctica/McMurdo">
								New Zealand Standard Time
								</option><option value="Etc/GMT-12" ng-reflect-value="Etc/GMT-12">
								UTC+12
								</option><option value="Pacific/Fiji" ng-reflect-value="Pacific/Fiji">
								Fiji Standard Time
								</option><option value="Asia/Anadyr" ng-reflect-value="Asia/Anadyr">
								Magadan Standard Time
								</option><option value="Asia/Kamchatka" ng-reflect-value="Asia/Kamchatka">
								Kamchatka Standard Time
								</option><option value="Etc/GMT-13" ng-reflect-value="Etc/GMT-13">
								Tonga Standard Time
								</option><option value="Pacific/Apia" ng-reflect-value="Pacific/Apia">
								Samoa Standard Time
								</option>
							</select>
            </div>
            <div class="form-group">
              <label for="phone">Phone</label>
              <input [(ngModel)]="location.phone" name="phone" type="text" class="form-control"/>
            </div>
            <div class="form-group">
              <label for="city">City</label>
              <input [(ngModel)]="location.city" name="city" type="text" class="form-control"/>
            </div>
            <div class="form-group">
              <label for="prov">State / Province</label>
              <input [(ngModel)]="location.prov" name="prov" type="text" class="form-control"/>
            </div>
            <div class="form-group">
              <label for="zip">Zip / Postal</label>
              <input [(ngModel)]="location.zip" name="zip" type="text" class="form-control"/>
            </div>
            <div class="form-group">
              <label for="country">Country</label>
              <input [(ngModel)]="location.country" name="country" type="text" class="form-control"/>
            </div>
            <div class="form-group">
              <button (click)="submitForm()" type="submit" class="btn btn-sm btn-primary">Save</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
